import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

type OutletTableItem =
{
  name: string,
  link: string,
  credits: {
    is_calculated:boolean,
    is_manual:boolean,
    equity: number,
    ownership: number,
    name:string
  }[]
}

@Component({
    selector: 'app-committee-deal-information',
    templateUrl: './committee-deal-information.component.html',
    styleUrls: ['./committee-deal-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommitteeDealInformationComponent implements OnInit {
  @Input() deal: any;
  row1: Array<any> = [];
  row2: Array<any> = [];
  shouldExpand = true;
  outlets:OutletTableItem[] = [];
  ngOnInit() {
    for (let i = 0; i < this.deal.info.length; i++) {
      if(this.deal.info[i].key !== 'Closing Date'){
        this.row1.push(this.deal.info[i]);
      }
      //add first four tds then add credit tds that takes up two rows
      if (i === 3) {
        this.row2.push({
          key: 'Credit Types',
          value: this.deal.creditTypes,
          expandRow: true,
        });
      }
      this.outlets = this.deal.creditOutlets;
    }
    //add second four tds to make room for credit tds from row above
    // else if(i === 7){
    //     }
    //     //add the rest of the tds into rows of 6
    //     else if(i > 7 && (i + 5) % 6 === 0 ){
    //       this.infodata.push(row);
    //       row = [];
    //     }
    //
    //     else if(i === this.deal.info.length - 1 && row !== []){
    //       this.infodata.push(row);
    //       row = [];
    //     }
    //   }
  }
  getColumnClasses(row: any, data: any): string[] {
    if (row.length === 2) {
      return ['col-6', 'info-column'];
    } else if (row.length === 1){
      return ['col-12', 'info-column'];
    } else {
      return ['col-6', 'col-md-4', 'col-lg-3', 'info-column'];
    }
  }
  isArray(info: any): boolean {
    return Array.isArray(info);
  }

  isString(info: any): boolean {
    return typeof info === 'string';
  }
}
